import { useTranslation } from 'react-i18next'

import { QA_NAME_REFRESH_BTN } from '../../../../constants/qa'
import { TableControlIcon } from '../../TableControlIcon'

import RefreshIcon from '../../../../icons/refresh.svg'

function TableRefreshButton({
  labelKey = 'Table.RefreshBtnKey',
  qaName = QA_NAME_REFRESH_BTN,
  tooltip = labelKey,
  ...restProps
}) {
  const { t } = useTranslation()

  return (
    <TableControlIcon
      {...restProps}
      Icon={RefreshIcon}
      qaName={qaName}
      tooltip={t(tooltip)}
    />
  )
}

export default TableRefreshButton
